import {
    ref, nextTick,
} from 'vue';
import '../lang/notification';
import {
    log,
} from '../utils/action-logger';
import {
    useProfileStore,
} from '../stores/profile-store';

export const minitaskEvents = ['updated', 'skipped'];

export function useMinitaskEditForm({ key = '', validate = () => true, emit, onSave }) {
    const profile = useProfileStore();
    const dirty = ref(false);

    function markAsDirty() {
        dirty.value = true;
    }

    async function save() {
        await nextTick();
        dirty.value = false;
        await profile.updateProfile(profile.model);
    }

    function skipped() {
        emit('skipped');
        log('profile-minitask', {
            label: key,
            result: 'skip',
        });
    }

    function saveData() {
        if (validate()) {
            onSave?.();
            save();
            emit('updated');
            log('profile-minitask', {
                label: key,
                result: 'save',
            });
        }
    }

    return {
        save,
        markAsDirty,
        dirty,
        skipped,
        saveData,
    };
}
